import { render, staticRenderFns } from "./SwitchStatus.vue?vue&type=template&id=78fa44f3"
import script from "./SwitchStatus.vue?vue&type=script&lang=js"
export * from "./SwitchStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports